<ng-container *ngIf="!!params">
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</ng-container>
